import Amplitude from "amplitude-js";


const amplitudeClient = Amplitude.getInstance();
let useAnalyticsAPI = false;

// @ts-ignore need to do this because we comment out the key in config
if (site["analyticsAPIKey"]) {
  useAnalyticsAPI = true;
  // @ts-ignore
  amplitudeClient.init(site["analyticsAPIKey"]);
} else {
  // @ts-ignore
  amplitudeClient.init("FAKEAPIKEY", null, site["amplitudeConfig"]);
  useAnalyticsAPI = true;
}

const useAnalyticsAPIProduction = site.useAnalyticsAPIEnv === "prod"; // this controls whether or not data goes to the 'real' chart
const useAnalyticsAPIStaging = true && site.useAnalyticsAPIEnv === "staging"; // data goes to test chart. should be true usually, unless you specifically DON'T want logging from staging
const useAnalyticsAPIDevelopment = true && site.useAnalyticsAPIEnv === "development"; // data goes to test chart. Should be false when submitting a PR. devs can toggle via changing true/false.

export const setAnalyticsUserId = (id: string): void => {
  if (useAnalyticsAPI) {
    amplitudeClient.setUserId(id);
  }
};

export const logEvent = async (eventName: string, params?: Record<string, string>): Promise<void> => {
  if (
    useAnalyticsAPIProduction // always log in prod
    || useAnalyticsAPIStaging // log in staging if opted in
    || useAnalyticsAPIDevelopment // log in dev if opted in
  ) {
    amplitudeClient.logEvent(eventName, { ...params });
  }
};

export const ANALYTIC_EVENTS = {
  LANDING_PAGE: "user landed on landing page",
  PLAN_BENEFIT: "plan benefit page",
  PHARMACY_AND_DRUG_SEARCH: "pharmacy or drug search start button click",
  FIND_PHARMACY: "find pharmacy button click",
  DRUG_PRICING_RESULTS_PAGE: "drug pricing results page",
  DRUG_PRICING_MESSAGE: {
    common: {
      reject_mr_or_70: "drug pricing msg common reject mr or 70",
      reject_insuppressible: "drug pricing msg common reject insuppressible",
      reject_price_may_vary: "drug pricing msg common reject price may vary",
      reject_special_approval: "drug pricing msg common reject special approval",
      reject_quantity_limit: "drug pricing msg common reject quantity limit",
    },
    brand: {
      reject_mr_or_70: "drug pricing msg brand reject mr or 70",
      reject_insuppressible: "drug pricing msg brand reject insuppressible",
      reject_price_may_vary: "drug pricing msg brand reject price may vary",
      reject_special_approval: "drug pricing msg brand reject special approval",
      reject_mr_or_70_brand_only: "drug pricing msg brand reject mr or 70 brand only",
      reject_insuppressible_brand_only: "drug pricing msg brand reject insuppressible brand only",
      reject_none: "drug pricing msg brand reject none",
    },
    generic: {
      reject_mr_or_70: "drug pricing msg generic reject mr or 70",
      reject_insuppressible: "drug pricing msg generic reject insuppressible",
      reject_price_may_vary: "drug pricing msg generic reject price may vary",
      reject_special_approval: "drug pricing msg generic reject special approval",
      reject_mr_or_70_generic_only: "drug pricing msg generic reject mr or 70 generic only",
      reject_insuppressible_generic_only: "drug pricing msg generic reject insuppressible generic only",
      reject_none: "drug pricing msg generic reject none",
    },
    partial_results: "drug pricing msg partial results",
    partial_results_bottom_case: "drug pricing msg partial results bottom case",
    partial_results_no_brand_some_generic_insuppressible: "drug pricing msg partial results no brand some generic insuppressible",
  },
  PHARMACY_ONLY_SEARCH_RESULTS: "pharmacy only search results page",
  VIEW_FORMULARY: "view formulary button click",
  PLAN_DOCUMENT: {
    new_tab: "open plan document in new tab",
    download: "download plan document",
  },
  M3P: "m3p learn more button click",
  PAYMENT_CALCULATOR: "payment calculator calculation",
};
